export default {
  'receipt.title': 'Информация о платежах',
  'receipt.btn.add': 'Добавить',
  'receipt.btn.import': 'Импорт',
  'receipt.btn.export': 'Экспорт',
  'receipt.input.placeholder': 'Введите информацию об платеже.',
};
